<template>
  <div className="group17 flex-col">
    <div className="section5 flex-col">
      <div className="bd11">
        <span className="word15">待缴费车辆</span>
      </div>
    </div>
    <div style="display: flex; height: 86%">
      <div className="section8 flex-col" v-if="showList.length > 0">
        <div className="wrap1 flex-row" v-for="(item, index) in showList" :key="item.id" @click="onTab(index)" :style="{
          background: index === tabIndex ? '#3A394F' : '',
        }">
          <div class="txt5">{{ item.numberPlate }}</div>

          <img src="../../assets/image/close.png" :style="{
            width: '16px',
            height: '16px',
            margin: '0px 0px 1px 5px',
          }" alt="" @click="closeNumberPlate(item)" />
        </div>
      </div>
      <div v-if="showList.length > 0" style="
          width: 74%;
          display: flex;
          flex-direction: column;
          align-items: center;
        ">
        <span className="word17">{{ showList[tabIndex].numberPlate }}</span>

        <div className="section7 flex-col">
          <span className="word18">
            <span>{{ getNameByFlagKey(showList[tabIndex].carType) }}</span>
            <span v-if="showList[tabIndex].cfCarParkPackage && Number(showList[tabIndex].cfCarParkPackage.endTime)<getCurrentTime()"> / 已过期</span>
            <span v-if="showList[tabIndex].cfCarParkPackage && Number(showList[tabIndex].cfCarParkPackage.endTime)>getCurrentTime() && showList[tabIndex].homeGroup"> / 占位</span>
          </span>
        </div>
        <div style="display: flex">
          <div className="word19">总应收款:¥{{ showList[tabIndex].cfOrder.amountsPayable }}</div>


          <!-- <span className="word19" v-else>总应收款:¥{{
              showList[tabIndex].cfOrder.amountsPayable - showList[tabIndex].cfCouponList[0].denomination
            }}</span> -->
          <el-popover placement="top" width="160" v-model:visible="visibleShow">
            <p>请输入优惠金额</p>
            <el-input placeholder="请输入" type="Number" style="margin-top: 5px" v-model="modifiedAmount"></el-input>
            <div style="text-align: right; margin: 6px 0 0 0">
              <el-button size="mini" type="text" @click="visibleShow = false">取消</el-button>
              <el-button type="primary" size="mini" :disabled="!modifiedAmount" @click="confirmChangeAmount">确定
              </el-button>
            </div>
            <template #reference>
              <el-button type="danger" icon="el-icon-edit" size="mini" circle
                style="margin-left: 6px; width: 40px; height: 40px"></el-button>
            </template>
          </el-popover>
        </div>
        <div style="display: flex">
          <div className="word19" style="display: block;" v-if="showList[tabIndex]?.discountedPrice != null">优惠金额:¥{{
            showList[tabIndex].discountedPrice }}</div>
        </div>

        <span className="word20">{{
            showList[tabIndex].inTime!=='0' ? getParkingTime(
            Number(showList[tabIndex].inTime),
            Number(showList[tabIndex].outTime)
          ) : '无入场信息'
        }}</span>
        <!-- <span className="word21">应收:0</span> -->
        <!-- <div style="display: flex; margin-top: 10px">
          <span className="word22"
          >代收:{{ showList[tabIndex].cfOrder.collectionAmount }}</span
          >

          <span className="word23"
          >优惠券抵扣:{{
              showList[tabIndex].cfCouponList.length > 0 ? showList[tabIndex].cfCouponList[0].denomination : '-'
            }}</span
          >
        </div> -->
        <span className="txt4">备注信息：{{ showList[tabIndex].remarks || "暂无" }}</span>

        <span className="info10">入场信息：{{ showList[tabIndex].inCheckPointName ?? "" }}</span>

        <span className="word24">入场时间：{{
          getTimeFormat(Number(showList[tabIndex].inTime))
        }}</span>
        <span className="word25">出场信息：{{ showList[tabIndex].outCheckPointName ?? "" }}</span>
        <span className="txt6">出场时间：{{
          getTimeFormat(Number(showList[tabIndex].outTime))
        }}</span>
        <span className="txt6" style="color: #fa4408" v-if="showList[tabIndex].cfCarParkPackage && Number(showList[tabIndex].cfCarParkPackage.endTime)<getCurrentTime()">车辆过期时间：{{
            getTimeFormat(Number(showList[tabIndex].cfCarParkPackage.endTime))
          }}</span>
        <div style="
            display: flex;
            justify-content: space-evenly;
            width: 100%;
            margin-top: 20px;
          ">
          <div v-if="showList[tabIndex].inTime!=='0'" class="section9 flex-col" @click="openDoor('toll')">
            <span class="info11">收费放行</span>
          </div>
          <div v-if="showList[tabIndex].inTime==='0'" class="section9 flex-col" @click="handleNoInTime(showList[tabIndex])">
            <span class="info11">补录入场</span>
          </div>
          <div class="section10 flex-col" @click="onAbnormalRelease">
            <span class="info12">异常放行</span>
          </div>
          <div class="section13 flex-col" @click="showFeeReason(showList[tabIndex])">
            <span class="info12">收费原因</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <el-dialog title="选择异常原因" v-model="openDoorDialogVisible" :modal-append-to-body="false" width="30%" center>
    <div class="Box">
      <div v-for="(item, index) of filteredAbnormalReleaseReason" :key="index" :class="index === reasonIndex ? 'reasonBox_ac' : 'reasonBox'"
        @click="onReason(index)">
        {{ item }}
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="danger" @click="openDoor('abnormal')" :disabled="reasonIndex === ''">确 定</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 补录弹框 -->
  <el-dialog
      v-model="supplementaryEnrollmentVisible"
      title="补录入场"
      :modal-append-to-body="false"
      width="520px"
      center
      :close-on-click-modal="false"
      :append-to-body="true"
  >
    <div class="release-in-card">
      <el-form label-width="96px" label-position="left" class="release-in-form">
        <el-form-item label="当前车牌">
          <span class="release-in-value">
            {{ carParkUseLog.numberPlate }}
          </span>
        </el-form-item>
        <el-form-item label="入场时间">
          <span class="release-in-value">
            <el-date-picker
                v-model="carParkUseLog.newInTime"
                type="datetime"
                placeholder="请选择"
                clearable
            />
          </span>
        </el-form-item>
        <el-form-item label="入场通道">
          <span class="release-in-value">
            <el-select
                v-model="carParkUseLog.inCheckPointId"
                placeholder="请选择"
                :clearable="true"
            >
                <el-option
                    v-for="item in checkPointList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
          </span>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="release-in-footer">
        <el-button type="primary" @click="confirmEditCarSupplementaryEnrollment">确认补录</el-button>
        <el-button @click="supplementaryEnrollmentVisible = false">取消</el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog :title="feeReasonTitle" v-model="feeReaSonDialogVisible" :modal-append-to-body="false" width="30%" center>
    <div class="Box">
      <div v-for="(item, index) of feeReasonList" :key="index" style="width: 100%">
        {{ item.illustrate }}
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="danger" @click="feeReaSonDialogVisible=false" >知道了</el-button>
      </span>
    </template>
  </el-dialog>

</template>
<script>
import { mapGetters, mapState } from "vuex";
import { toRaw } from "vue";
// 
import { $getParkingTime, $timeFormat } from "../../utils/index";
import {
  oneClickRelease,
  newOneClickRelease,
  getCheckPointByQuery,
  simpleModifications,
  getCarParkUseLogOrder, getUseLogFeeIllustrateList
} from "@/network/api";
import { cloneDeep } from "lodash";
import {ElMessage, ElMessageBox} from "element-plus";
import dayjs from "dayjs";
import store from "@/store";
var times = null;
export default {
  emits: ["countPayAmountByDuty"],
  data() {
    return {
      visibleShow: false,
      supplementaryEnrollmentVisible: false,
      modifiedAmount: "",
      list: [],
      tabIndex: 0,
      openDoorDialogVisible: false,
      feeReaSonDialogVisible: false,
      reasonIndex: "",
      showList: [],
      carParkUseLog: {
        id: '',
        numberPlate: '',
        inCheckPointId: '',
        inCheckPointName: '',
        remarks: '',
        inTime: '',
        newInTime: '',
        newOutTime: ''
      },
      checkPointList:[],
      feeReasonList:[],
      feeReasonTitle: '收费原因',
    };
  },
  created() {
    if (localStorage.getItem("ChargeLocalList")) {
      this.list = JSON.parse(localStorage.getItem("ChargeLocalList"));
      this.setTabIndex();
      // 获取所有的车辆类型
      this.$store.dispatch("getAllCarType");
    }
    // this.clearChargeLocalList();
  },
  computed: {
    ...mapState([
      "chargeCar",
      "paidCar",
      "globalConfig",
      "carParkIndex",
      "carTypeList",
      "abnormalReleaseReason",
      "outCar"
    ]),
    ...mapGetters(["carParkId"]),
    filteredAbnormalReleaseReason() {
      const monthlyOrProperty = ["月卡/产权占位", "月卡/产权逾期", "月卡/产权换车"];
      const tempCar = ["电子支付未抬杆", "公务车", "内部车", "欠费离场", "线下优惠券"];

      const current = this.showList?.[this.tabIndex];
      if (!current) return this.abnormalReleaseReason || [];

      const typeName = this.getNameByFlagKey(current.carType) || "";
      const isMonthlyOrPropertyCar =
        typeName.includes("月") || typeName.includes("产权") || typeName.includes("租");

      return isMonthlyOrPropertyCar ? monthlyOrProperty : tempCar;
    },
    // eslint-disable-next-line vue/no-dupe-keys
    // list:function (){
    //   return []
    // }
  },
  watch: {
    chargeCar: function (value) {
      this.processingData(toRaw(value));
    },
    // 监听已支付的车辆
    paidCar: function (value) {
      this.setPaidCar(toRaw(value));
    },
    carParkIndex: function () {
      this.showList = this.list.filter((i) => i.carParkId === this.carParkId);
    },
    list: {
      deep: true,
      handler: function (value) {
        // console.log('value发生了变化',value)
        this.showList = value.filter((i) => i.carParkId === this.carParkId); //只显示被选择的停车场的数据
      },
    },
  },
  methods: {
    getNameByFlagKey(flagKey) {
      const arr = this.carTypeList
      const foundItem = arr.find((item) => item.flagKey === flagKey);
      return foundItem ? foundItem.name : null;
    },
    // 点击修改金额
    async confirmChangeAmount() {
      var { modifiedAmount, tabIndex, showList } = this;
      var info = showList[tabIndex];
      const amountsPayable = parseFloat(info.cfOrder.amountsPayable);
      if (modifiedAmount > amountsPayable) {
        this.$message({
          message: "不能大于等于总应付金额",
          type: "error",
        });
        return;
      }
      info.discountedPrice = modifiedAmount
      showList[tabIndex] = info
      localStorage.setItem("ChargeLocalList", JSON.stringify(showList));
      this.modifiedAmount = "";
      this.visibleShow = false;
      // var { message, code } = await newOneClickRelease({
      //   deductionAmount:modifiedAmount,
      //   openDoor:1,
      //   useLogId: info.id
      // });
      // if (code === 10002) {
      //   console.log(info);
      //   console.log(this.list);

      //   // 修改总应收款金额
      //   var list = cloneDeep(this.list);
      //   for (const i in list) {
      //     if (list[i].id === info.id) {
      //       list[i].cfOrder.amountsPayable = (
      //         list[i].cfOrder.amountsPayable - modifiedAmount
      //       ).toFixed(2);
      //     }
      //   }
      //   this.list = list;
      //   window.localStorage.setItem(
      //     "ChargeLocalList",
      //     JSON.stringify(this.list)
      //   );
      //   // this.resetTiming();
      //   this.modifiedAmount = "";
      //   this.visibleShow = false;
      // }
      // this.$message({
      //   message,
      //   type: code === 10002 ? "success" : "error",
      // });
    },
    // 点击关闭车牌
    closeNumberPlate(item) {
      const itemId = item.id;
      const list = cloneDeep(this.list);
      console.log(list);
      ElMessageBox.confirm(`确定删除${item.numberPlate}吗？`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.list = list.filter((i) => i.id !== itemId);
        window.localStorage.setItem(
          "ChargeLocalList",
          JSON.stringify(this.list)
        );
        // this.resetTiming();
        this.tabIndex = 0;
      });
    },
    // 修改已支付车辆数据
    setPaidCar(value) {
      // console.log("value", value);
      const numberPlate = value.numberPlate;

      for (const item of this.list) {
        if(item.id===value.id){
          item.outReleaseType = 1;
          break;
        }
      }

      const cloneList = cloneDeep(this.list);

      // 将这个车牌在列表中删除
      this.list = cloneList.filter((i) => i.numberPlate !== numberPlate);
      localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
      // this.resetTiming();
      this.tabIndex = 0;

      if (this.globalConfig.promptPayCar) {
        ElMessage({
          message: `${numberPlate}已支付成功`,
          type: "success",
        });
      }
    },
    onReason(index) {
      this.reasonIndex = index;
    },
    getParkingTime(inTime, outTime) {
      return $getParkingTime(inTime, outTime);
    },
    getTimeFormat(time) {
      return $timeFormat(time, "YYYY-MM-DD HH:mm:ss");
    },
    resetTiming() {
      clearInterval(times);
      this.clearChargeLocalList();
    },
    // 检测来了新的收费车辆
    processingData(data) {
      if (this.list.length > 60) {
        this.list = this.list.slice(0, 60);
      }
      var list = cloneDeep(this.list);
      const { id } = data;
      this.list = list.filter((i) => i.id !== id);
      localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
      // this.resetTiming();
      // this.list.push(data);
      this.list.unshift(data);
      // this.setTabIndex();
      localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
      this.handleNoInTime(data);
    },
    handleNoInTime(data){
      if(data.inTime==='0' && data.outReleaseType==='0'){
        this.carParkUseLog = data;
        this.supplementaryEnrollmentVisible = true;
        //查询对应的入场通道
        getCheckPointByQuery({
          areaId: data.carParkId,
          deviceType: 2,
          page: 1,
          size: 20,
          onlyLink: 1,
          features: 'in',
        }).then((res) => {
          if(res.code === 10002) {
            this.checkPointList = res.data;
            this.carParkUseLog.inCheckPointId = res.data[0].id;
            this.carParkUseLog.inCheckPointName = res.data[0].name;
          }else{
            this.checkPointList = [];
            this.carParkUseLog.inCheckPointId = '';
            this.carParkUseLog.inCheckPointName = '';
          }
        });
      }
    },
    setTabIndex() {
      if (this.list.length > 0) {
        this.tabIndex = 0;
      }
    },
    onTab(index) {
      this.tabIndex = index;
    },
    // 点击了异常放行
    onAbnormalRelease() {
      // 打开弹窗时重置选择，避免车辆切换后索引越界
      this.reasonIndex = "";
      this.openDoorDialogVisible = true;
    },
    async showFeeReason(item) {
      const res = await getUseLogFeeIllustrateList({
        id: item.id
      });
      if (res.code === 10002) {
        this.feeReasonTitle = item.numberPlate + '-收费原因';
        this.feeReasonList = res.data;
        this.feeReaSonDialogVisible = true;
      } else {
        this.$message.error(res.message);
      }
    },
    async openDoor(type) {
      var info = this.list[this.tabIndex];
      // 收费放行
      if (type === "toll") {
        // ElMessageBox.confirm(`${info.cfCarParkUseLog.numberPlate}出场收费${info.cfOrder.amountsPayable}元`, '提示',
        //     {
        //       confirmButtonText: '确认放行',
        //       cancelButtonText: '取消',
        //       type: 'warning',
        //     })
        const amountsPayable = info.cfOrder.amountsPayable;
        const discountedPrice = info?.discountedPrice
        var stringText = ''
        if (discountedPrice) {
          stringText = `<strong style='font-size:25px'>${info.numberPlate}出场收费<i style='color:red;'>${amountsPayable}</i>元； 优惠<i style='color:red;'>${discountedPrice}</i>元；总收<i style='color:red;'>${amountsPayable - discountedPrice}</i>元</strong>； `
        } else {
          stringText = `<strong style='font-size:25px'>${info.numberPlate}出场收费<i style='color:red;'>${amountsPayable}</i>元</strong> `
        }
        ElMessageBox.alert(
          stringText,
          "收费提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确认放行",
            cancelButtonText: "取消",
            showCancelButton: true,
            type: "warning",
          }
        )
          .then(async () => {
            // const cfCouponList = info.cfCouponList;
            const res = await newOneClickRelease({
              deductionAmount: discountedPrice || 0,
              useLogId: info.id,
              openDoor: 1,
              reason: '人工现金收费放行',
              releaseType: 2,
              direction: 1  //0-入场/1-出场
              // couponId: cfCouponList.length > 0 ? cfCouponList[0].id : "",
            });
            // console.log(res);
            if (res.code === 10002) {
              this.$message({
                message: res.message,
                type: "success",
              });
              for (const item of this.list) {
                if(item.id===info.id){
                  item.outReleaseType = 2;
                  break;
                }
              }
              this.list = this.list.filter(
                (i) => i.cfOrder.id !== info.cfOrder.id
              );
              localStorage.setItem(
                "ChargeLocalList",
                JSON.stringify(this.list)
              );
              // this.resetTiming();
              this.tabIndex = 0;
              // 更新顶部今日现金收费
              this.$emit("countPayAmountByDuty");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => console.log(err));
      } else if (type === "abnormal") {
        // 异常放行
        const reasonList = this.filteredAbnormalReleaseReason || [];
        const reasonText = reasonList[this.reasonIndex];
        if (!reasonText) return;
        var { message } = await oneClickRelease({
          useLogId: info.id,
          openDoor: 1,
          reason: reasonText,
          releaseType: 5,
          direction: 1  //0-入场/1-出场
        });
        this.$message({
          message,
          type: "success",
        });
        for (const item of this.list) {
          if(item.id===info.id){
            item.outReleaseType = 2;
            break;
          }
        }
        this.list = this.list.filter((i) => i.cfOrder.id !== info.cfOrder.id);
        localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
        // this.resetTiming();
        this.tabIndex = 0;
        this.openDoorDialogVisible = false;
      }
    },
    getCurrentTime(){
      return dayjs().valueOf();
    },
    async confirmEditCarSupplementaryEnrollment(){
      const res = await simpleModifications({
        numberPlate: this.carParkUseLog.numberPlate,
        id: this.carParkUseLog.id,
        inTime: dayjs(this.carParkUseLog.newInTime).valueOf(),
        inCheckPointId: this.carParkUseLog.inCheckPointId,
        inCheckPointName: this.carParkUseLog.inCheckPointName,
        inReleaseType: 2,
      });
      // console.log(res);
      if (res.code === 10002) {
        this.$message({
          message: res.message,
          type: "success",
        });
        //查询该停车记录账单
        const {code, data, message, mixMessage} = await getCarParkUseLogOrder({carParkUseLogId: this.carParkUseLog.id});
        if(code===10002){
          this.showList.map((i) => {
            if (i.id === data.id) {
              // i = data;
              i.inTime = data.inTime;
              i.inCheckPointId = data.inCheckPointId;
              i.inCheckPointName = data.inCheckPointName;
              i.cfOrder = data.cfOrder;
            }
          });
          console.log('_showList', this.showList);
          this.supplementaryEnrollmentVisible = false;
          localStorage.setItem("ChargeLocalList", JSON.stringify(this.showList));

          data.inReleaseType = 2;
          this.outCar.map((i) => {
            if (i.id === data.id) {
              i.inTime = data.inTime;
              i.inCheckPointId = data.inCheckPointId;
              i.inCheckPointName = data.inCheckPointName;
              i.cfOrder = data.cfOrder;
            }
          });
          // this.outCar = list;
          store.commit("SETALLOUT", this.outCar);
        }else{
          this.$message.error(message+','+mixMessage);
        }
      } else {
        this.$message.error(res.message);
      }
    },
    clearChargeLocalList() {
      var list = this.list;
      times = setInterval(() => {
        this.list = list.filter((i) => dayjs().valueOf() - i.outTime < 600000);
        localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
      }, 2000);
    },
  },
};
</script>

<style scoped>
.reasonBox {
  width: 90px;
  height: 36px;
  background: #efefef;
  border-radius: 3px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-weight: 500;
  color: #323233;
  line-height: 36px;
  margin-bottom: 16px;
  /* margin-right: 20px; */
  text-align: center;
}

.reasonBox_ac {
  width: 90px;
  height: 36px;
  background: #fc4408;
  border-radius: 3px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-weight: 500;
  color: #ffffff;
  line-height: 36px;
  margin-bottom: 16px;
  /* margin-right: 20px; */
  text-align: center;
}

.Box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.release-in-card {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #f6f6f6;
  padding: 18px 18px 4px;
  overflow: visible;
}

.release-in-form :deep(.el-form-item) {
  margin-bottom: 14px;
}

.release-in-form :deep(.el-form-item__label) {
  color: #999999;
  font-weight: 500;
}

.release-in-value {
  color: #373c40;
  font-size: 14px;
  font-weight: 500;
}

/* 纠错：省份网格 + 车牌输入（参考补录选牌样式） */
.edit-plate-field {
  position: relative;
  width: 100%;
}

.edit-plate-composite {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 36px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.edit-plate-composite:focus-within {
  border-color: rgba(8, 123, 252, 0.6);
}

.edit-plate-body-input {
  flex: 1;
  min-width: 0;
}

.edit-plate-body-input :deep(.el-input__wrapper) {
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  padding-left: 10px;
}

.edit-plate-body-input :deep(.el-input__inner) {
  text-align: left;
  border: none !important;
  box-shadow: none !important;
}

.edit-plate-province-badge {
  flex-shrink: 0;
  width: 36px;
  margin: 2px;
  border: none;
  border-radius: 4px;
  background: rgba(8, 123, 252, 1);
  color: #fff;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.edit-plate-province-badge:hover {
  background: rgba(8, 123, 252, 0.85);
}

.edit-plate-keyboard {
  position: absolute;
  left: 0;
  top: calc(100% + 6px);
  z-index: 20;
  padding: 10px;
  background: #f0f2f5;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e4e7ed;
}

.edit-plate-key-row {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 6px;
  margin-bottom: 6px;
}

.edit-plate-key-row:last-child {
  margin-bottom: 0;
}

.edit-plate-key {
  width: 100%;
  aspect-ratio: 1;
  min-width: 0;
  min-height: 32px;
  padding: 0;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.edit-plate-key:hover {
  border-color: rgba(8, 123, 252, 0.5);
  color: rgba(8, 123, 252, 1);
}

.edit-plate-key.is-active {
  background: #ff9e3c;
  border-color: #ff9e3c;
  color: #fff;
}

.release-in-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.release-in-primary {
  background: rgba(8, 123, 252, 1);
  border-color: rgba(8, 123, 252, 1);
}

.release-in-primary:hover,
.release-in-primary:focus {
  background: rgba(8, 123, 252, 0.9);
  border-color: rgba(8, 123, 252, 0.9);
}

.release-in-dialog :deep(.el-dialog__header) {
  padding-top: 18px;
}

.release-in-dialog :deep(.el-dialog__title) {
  font-size: 20px;
  font-weight: 500;
  color: #373c40;
}

.release-in-dialog :deep(.el-dialog__body) {
  padding-top: 12px;
  padding-bottom: 8px;
  overflow: visible;
}
</style>
